export const FacebookLogo = () => (
  <svg
    aria-labelledby='facebookLogoTitle'
    fill='none'
    height='24'
    role='img'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='facebookLogoTitle'>Facebook logo</title>
    <g clipPath='url(#clip0_11194_5363)'>
      <path
        d='M24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 17.9895 4.38825 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9705 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.3399 7.875 13.875 8.80003 13.875 9.74906V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6117 22.954 24 17.9896 24 12Z'
        fill='#1877F2'
      />
      <path
        d='M16.6711 15.4688L17.2031 12H13.875V9.74906C13.875 8.79994 14.3399 7.875 15.8306 7.875H17.3438V4.92188C17.3438 4.92188 15.9705 4.6875 14.6575 4.6875C11.9166 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4688H10.125V23.8542C10.7453 23.9514 11.3722 24.0002 12 24C12.6278 24.0002 13.2547 23.9514 13.875 23.8542V15.4688H16.6711Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_11194_5363'>
        <rect
          fill='white'
          height='24'
          width='24'
        />
      </clipPath>
    </defs>
  </svg>
);
